/**
 * @generated SignedSource<<48b2d28b58ce5c36929518a9c14a2471>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPickerClassicProject$data = {
  readonly __typename: "Project";
  readonly closed: boolean;
  readonly columns: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null> | null;
  };
  readonly id: string;
  readonly number: number;
  readonly title: string;
  readonly viewerCanUpdate: boolean;
  readonly " $fragmentType": "ProjectPickerClassicProject";
};
export type ProjectPickerClassicProject$key = {
  readonly " $data"?: ProjectPickerClassicProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPickerClassicProject">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ProjectPickerClassicProject"
};

(node as any).hash = "ad16e4117cc8ab37b1da94ff3d835d82";

export default node;
